<template>
  <div class="CIT_background">
    <div class="position" style="display: flex; flex-direction: column">
      <template v-if="loading">
        <div
          class="vertical-center"
          style="margin-top: 23%; margin-bottom: 20%"
        >
          <LoadingMDL />
        </div>
      </template>
      <template v-else>
        <div
          style="
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-left: auto;
            margin-right: auto;
          "
          class="container_mobile"
        >
          <h1 style="font-weight: bold">{{ index_page }}/{{ total_page }}</h1>
          <div class="card">
            <div class="container_CIT02">
              <div v-if="getWidth >= 1024">
                <div class="btn-prev" v-if="flipped">
                  <ButtonIcon
                    :bgColor="`#e6efff`"
                    :iconUrl="prev_icon"
                    :size="1"
                    @click="toggleCard('back')"
                  />
                </div>
              </div>
              <div class="block">
                <div class="flashcard-list">
                  <transition name="flip">
                    <template v-if="!flipped">
                      <img style="width: 100%; height: 100%" :src="image" />
                    </template>
                    <template v-if="flipped">
                      <div class="box_question">
                        <div class="header_text">
                          <div
                            style="
                              display: flex;
                              justify-content: center;
                              align-items: center;
                            "
                            v-for="(value, index) in pinyin.split('//')"
                            :key="index"
                          >
                            <a class="fontPinyin header_text_pinyin">{{ value }}</a>
                          </div>
                          <div
                            style="
                              display: flex;
                              justify-content: center;
                              align-items: center;
                            "
                             v-for="(value, index) in title.split('//')"
                            :key="index"
                          >
                            <a class="fontChinese header_text_title">{{ value }}</a>
                          </div>
                          <button
                            style="margin-top: 10px"
                            type="button"
                            class="btn btn-circle btn-lg"
                            @click.prevent="playSound()"
                          >
                            <i class="fas fa-bullhorn"></i>
                          </button>
                        </div>
                        <div class="line_question"></div>
                        <div class="meaning_text">
                          <div
                            style="
                              display: flex;
                              justify-content: center;
                              align-items: center;
                            "
                          >
                            <a>{{ type }}</a>
                          </div>
                          <a>{{ checkLanguage(tmpContent.description) }}</a>
                        </div>
                      </div>
                    </template>
                  </transition>
                </div>
              </div>
            </div>
          </div>
          <div class="btn-exit">
            <ButtonIcon
              :iconUrl="'/icons/close.svg'"
              :bgColor="`#ed8e91`"
              :size="1"
              @click="onClose()"
            />
          </div>
        </div>
      </template>
      <CRow
        v-if="getWidth >= 1024"
        style="
          display: flex;
          justify-content: center;
          margin-left: auto;
          margin-right: auto;
        "
      >
        <CCol col="2"></CCol>
        <div class="button button_setting" @click="toggleCard('next')">
          <CCol col="4" v-if="!flipped">
            <i class="fab fa-flipboard fa-3x"></i>
          </CCol>
          <CCol col="8">
            <div style="font-size: 18px; margin-left: 5px">
              {{ isFilped }}
            </div>
          </CCol>
        </div>
      </CRow>
      <CRow
        v-else
        style="
          display: flex;
          justify-content: center;
          margin-left: auto;
          margin-right: auto;
        "
      >
        <div
          class="button button_back"
          v-if="flipped"
          @click="toggleCard('back')"
        >
          <CCol col="8">
            <div style="font-size: 18px">Back</div>
          </CCol>
        </div>
        <div
          style="margin-left: 10px"
          class="button button_setting"
          @click="toggleCard('next')"
        >
          <CCol col="4">
            <i class="fab fa-flipboard fa-3x"></i>
          </CCol>
          <CCol col="8">
            <div style="font-size: 18px; margin-left: 5px">Next</div>
          </CCol>
        </div>
      </CRow>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ButtonIcon from "@/components/elements/Buttons/ButtonIcon";
import Card from "@/components/elements/Card";
import "../../assets/scss/chinessStyle2.scss";
import LoadingMDL from "../../components/loading/LoadingMDL";

export default {
  components: { ButtonIcon, Card, LoadingMDL },
  name: "FCV01",
  props: {},
  data() {
    return {
      audioUrl: "https://ccrma.stanford.edu/~jos/mp3/bachfugue.mp3",
      flipped: false,
      currentRoute: "",
      index_page: 0,
      total_page: 0,
      prev_icon: "/icons/arrow-left.svg",
      iconBar: "/icons/listen.svg",
      cards: {
        front: "/icons/planet-earth.svg",
      },
      content: [],
      tmpContent: [],
      baseUrl: process.env.VUE_APP_URL_SOUND,
      isFilped: "FLIP",
      language: this.$store.getters["language/getLanguage"],
      image:
        "https://endlessicons.com/wp-content/uploads/2012/11/image-holder-icon-614x460.png",
      pinyin: ". . . .",
      title: ". . . .",
      type: ". . . .",
      soundObject: {},
      getWidth: window.innerWidth.toString(),
      condition: [],
      startTime: this.$helpers.getDateFormat(),
      loading: true,
      criteria_id: "",
      templateData: {},
      code: "",
      section:"",
    };
  },
  methods: {
    toggleCard: function (val) {
      let numberOfOrder = this.content.content.item.length;
      if (val == "next") {
        this.flipped = !this.flipped;
        this.flipped == false
          ? (this.isFilped = "FLIP")
          : (this.isFilped = "NEXT");
        if (this.isFilped == "FLIP") {
          if (numberOfOrder != parseInt(this.tmpContent.order)) {
            let element = this.content.content.item.filter((el) => {
              if (el.order == parseInt(this.tmpContent.order) + 1) {
                return el;
              }
            });
            this.stopSound();
            this.tmpContent = element[0];
            this.index_page = this.index_page + 1;
          } else {
            this.commitUserProgress();
          }
        }
      } else if (val == "back") {
        this.flipped = !this.flipped;
        this.flipped == false
          ? (this.isFilped = "FLIP")
          : (this.isFilped = "NEXT");
      }
    },
    commitUserProgress() {
      this.loading = true;
      this.$store.dispatch("template/commitUserProgressChinese2", {
        // code: "605418cb883ae722ba1b0c5f",
        code:this.code,
        codeTemplate: this.templateData.templateData.codeTemplate,
        contentId: this.criteria_id,
        answering: [],
        startTime: this.startTime,
        endTime: this.$helpers.getDateFormat(),
        condition: this.condition,
        chapter: this.templateData.chapter,
        topic: this.templateData.topicPosition,
      });
    },
    checkLanguage(val) {
      if (val) {
        try {
          for (let i = 0; i <= val.length; i++) {
            if (val[i].key != null) {
              if (val[i].key.toUpperCase() == this.language.toUpperCase()) {
                return val[i].value;
              }
            }
          }
        } catch (err) {
          console.log("change language is error!!");
        }
      } else {
        console.log("change language is error!!");
      }
    },
    playSound() {
      this.soundObject.play();
    },
    stopSound() {
      this.soundObject.pause();
    },
    onClose() {
      this.$router.push("/LS01/1");
    },
  },
  computed: {
    ...mapGetters({
      getTemplateAndProgress: "template/getTemplateAndProgress",
      storeLanguage: "language/getLanguage",
      getResponseStatus: "template/getResponseStatus",
    }),
  },
  watch: {
    getTemplateAndProgress: function (data) {
      this.index_page = 1;
      this.total_page = data.templateData.content.item.length;
      this.templateData = data;
      // console.log("templateData ==> ", this.templateData);

      if (data.criteria.condition.criteriaType.length != 0) {
        this.condition.push({
          criteria: data.criteria.condition.criteriaType[0]._id,
          val: data.criteria.condition.criteriaType[0].val,
        });
      }
      this.criteria_id = data.criteria._id;
      this.content = data.templateData;
      this.tmpContent = this.content.content.item[0];
      this.loading = false;
    },
    storeLanguage: function (val) {
      this.language = val;
    },
    tmpContent: function () {
      this.image = this.baseUrl + "" + this.tmpContent.media[0].url;
      this.pinyin = this.tmpContent.title[3].value;
      this.title = this.tmpContent.title[2].value;
      this.type = this.tmpContent.message[1].value;
      this.soundObject = new Audio(
        this.baseUrl + "" + this.tmpContent.media[1].url
      );
    },
    getResponseStatus: function (value) {
      if (value.status == 200) {
        let route = this.content.navigate.next.action.split("-");
        this.$router.push("/" + route[0] + "/" + route[1]);
      }
    },
  },
  created() {
    this.currentRoute = this.$route.name + "-" + this.$route.params.id;
    this.courseData = this.$store.getters["necessary/getLerningCourse"]
    this.code = this.courseData._id;
    this.section = this.$store.getters['necessary/getUserCourseSection']
    console.log(this.section);
  },
  mounted() {
    let payload = {
      templateCode: this.currentRoute,
      // code: "605418cb883ae722ba1b0c5f",
      code:this.code,
      // section: "testing",
      section:this.section
    };
    this.$store.dispatch("template/fetchTemplateAndProgress", payload);
  },
  beforeDestroy() {},
};
</script>

<style scoped lang="scss">
.btn-exit {
  width: 60px;
  height: 60px;
  right: 30%;
  top: 15%;
  position: absolute;
}
.box_question {
  width: 400px;
  height: auto;
  margin-top: 3%;
  margin-bottom: 3%;
  display: flex;
  background-color: #f2f2f2;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}
.CIT_background {
  background-color: #ffdc77;
}
.header_text_pinyin {
  color: #89abe6;
  font-size: 34px;
  margin-left: 2%;
  margin-right: 2%;
}
.header_text_title {
  color: #89abe6;
  font-size: 60px;
  color: #000000;
  margin-left: 2%;
  margin-right: 2%;
}
.header_text {
  position: relative;
  text-align: center;
  margin-top: 10px;
  width: 100%;
}
.meaning_text a:nth-child(1) {
  color: #89abe6;
  font-size: 26px;
  margin-left: 2%;
  margin-right: 2%;
}
.meaning_text a:nth-child(2) {
  color: #89abe6;
  font-size: 34px;
  color: #000000;
  margin-left: 2%;
  margin-right: 2%;
}
.meaning_text {
  position: relative;
  text-align: center;
  width: 100%;
  margin-bottom: 3%;
}
.header_sound {
  position: absolute;
  width: 20px;
  height: 20px;
  right: 10%;
  top: 0;
  bottom: 0;
}
.meaning a:nth-child(1) {
  color: #89abe6;
  font-size: 20px;
}
.meaning a:nth-child(2) {
  color: #1d5bd7;
  font-size: 30px;
  font-weight: bold;
}
.meaning a {
  color: #89abe6;
  font-size: 20px;
  text-align: center;
}
.line_question {
  margin-top: 9%;
  margin-bottom: 4%;
  height: 2px;
  width: 60%;
  background-color: #d9d9d9;
}
.position {
  padding-top: 6%;
  display: flex;
  align-content: center;
  justify-content: center;
  padding-bottom: 10%;
}
.block {
  display: flex;
  justify-content: center;
  background-color: white;
  border-radius: 7px;
  width: 400px;
  height: auto;
  margin-top: 5%;
  margin-bottom: 5%;
}
.card {
  display: flex;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
  width: 450px;
  height: auto;
  background-color: white;
  margin-top: 8%;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  border-radius: 20px;
}

.container_CIT02 {
  margin-left: auto;
  margin-right: auto;
}
.button_setting {
  background-color: #89abe6;
  color: white;
  text-align: center;
  text-decoration: none;
  font-size: 12px;
  border-radius: 10px !important;
  box-shadow: none;
  margin-top: 6%;
  width: 250px;
  height: 70px;
}
.button_back {
  background-color: #ff6666;
  color: white;
  text-align: center;
  text-decoration: none;
  font-size: 12px;
  border-radius: 10px !important;
  box-shadow: none;
  margin-top: 6%;
  width: 250px;
  height: 70px;
}
.CIT02_ICON {
  display: flex;
  align-content: center;
  justify-content: center;
}
.btn-prev {
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  border-radius: 8px !important;
  right: 102%;
  cursor: pointer;
}
.btn-circle {
  width: 60px;
  height: 60px;
  padding: 6px 0px;
  border-radius: 30px;
  text-align: center;
  font-size: 16px;
  line-height: 1.42857;
  background-color: #1d5bd7;
  color: white;
}
.player {
  width: 100%;
  height: 100%;
}
.cardFlip {
  display: block;
  width: 150px;
  height: 175px;
  // padding: 80px 50px;
  background-color: #51aae5;
  border-radius: 7px;
  margin: 5px;
  text-align: center;
  line-height: 27px;
  cursor: pointer;
  position: relative;
  color: #fff;
  font-weight: 600;
  font-size: 20px;
  -webkit-box-shadow: 9px 10px 22px -8px rgba(209, 193, 209, 0.5);
  -moz-box-shadow: 9px 10px 22px -8px rgba(209, 193, 209, 0.5);
  box-shadow: 9px 10px 22px -8px rgba(209, 193, 209, 0.5);
  will-change: transform;
}

.flip-enter-active {
  transition: all 0.4s ease;
}

.flip-leave-active {
  display: none;
}

.flip-enter,
.flip-leave {
  transform: rotateY(180deg);
  opacity: 0;
}

.flashcard-form {
  position: relative;
}

@media screen and (min-width: 300px) and (max-width: 600px) {
  .container_CIT02 {
    margin-top: 5%;
    margin-bottom: 5%;
  }
  .position {
    padding-top: 30%;
    padding-bottom: 46%;
  }
  .block {
    width: 200px;
    height: auto;
  }
  .card {
    width: 250px;
    height: auto;
  }
  .btn-exit {
    width: 50px;
    height: 50px;
    right: 2% !important;
    top: 24% !important;
  }
  .btn-circle {
    width: 40px;
    height: 40px;
    padding: 6px 0px;
    border-radius: 30px;
    text-align: center;
    font-size: 16px;
    line-height: 1.42857;
    background-color: #1d5bd7;
    color: white;
  }
  .btn-prev {
    width: 60px;
    height: 60px;
    padding: 10px;
    right: 102%;
  }
  .fa-times {
    font-size: 45px;
  }
  .box_question {
    width: 200px;
    height: auto;
  }
  .header_text_pinyin {
    color: #89abe6;
    font-size: 20px;
  }
  .header_text_title {
    color: #89abe6;
    font-size: 40px;
    color: #000000;
  }
  .meaning_text a:nth-child(1) {
    color: #89abe6;
    font-size: 20px;
  }
  .meaning_text a:nth-child(2) {
    color: #1d5bd7;
    font-size: 24px;
  }
  .meaning_text {
    position: relative;
    text-align: center;
    width: 100%;
    margin-bottom: 5%;
  }
  .header_sound {
    width: 20px;
    height: 20px;
    right: 3%;
  }
  .button_setting {
    width: 150px;
    height: 45px;
  }
  .button_back {
    width: 150px;
    height: 45px;
  }
}
// IPAD
@media only screen and (min-width: 768px) and (max-width: 1023px) {
  .btn-exit {
    right: 10.7%;
    top: 20%;
  }
  .container_mobile {
    margin-top: 8%;
  }
}
// IPAD Horizon
@media only screen and (min-width: 1024px) and (max-width: 1365px) and (orientation: landscape) {
  .btn-exit {
    right: 19%;
    top: 25%;
  }
  .container_mobile {
    margin-top: 3%;
  }
}
// IPAD PRO
@media only screen and (min-width: 1024px) and (max-width: 1366px) and (orientation: portrait) {
  .btn-exit {
    right: 20%;
    top: 15.5%;
  }
  .container_mobile {
    margin-top: 5%;
  }
}
@media only screen and (min-width: 1366px) and (max-width: 1367px) and (orientation: landscape) {
  .btn-exit {
    right: 27.7%;
    top: 20%;
  }
  .container_mobile {
    margin-top: 2%;
  }
}
@media only screen and (min-width: 1036px) and (max-width: 1366px) {
  .btn-exit {
    right: 21.7%;
    top: 18.5%;
  }
}
@media only screen and (min-width: 1367px) and (max-width: 1440px) {
  .btn-exit {
    right: 29.7%;
    top: 12%;
  }
}
</style>
